import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
var templateUrl = require('./epxUnits.html');

class EpxUnitsController extends ComponentController {
  epxUnits: any[];
  canCreate: boolean;

  constructor(private $state: any, private EpxUnitService: any, private AuthService: any) {
    super();
  }

  $onInit() {
    this.canCreate = this.AuthService.hasPermission('EpxUnit', 'create');

    this.epxUnits = _.orderBy(this.epxUnits, 'group.name');
  }
}

angular.module('ciApp').component('epxUnits', {
  templateUrl: templateUrl,
  bindings: {
    epxUnits: '<'
  },
  controller: ['$state', 'EpxUnitService', 'AuthService', EpxUnitsController]
});



// WEBPACK FOOTER //
// ./app/admin/epx-units/epxUnits.component.ts